import { render } from "./resume-header.vue?vue&type=template&id=15afa8a7"
import script from "./resume-header.vue?vue&type=script&lang=js"
export * from "./resume-header.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__